import { useContext } from "react";
import QuestContext from "../../../../components/QuestWrapper";
import LeaderBoardCard from "./LeaderBoardCard";
import XP from "../../../../assets/images/xp.svg";
import { TopLeaderBoardProps } from "./leaderBoardTypes";
import config from "../../../../config";
import {
  questLogo,
  topLeadFirst,
  topLeadSecond,
  topLeadThird,
} from "../../../../assets/images";
import LeaderboardThemeManager from "./LeaderboardThemeManager";

const TopLeaderBoard: React.FC<TopLeaderBoardProps> = ({
  first,
  second,
  third,
  rest,
  memberShip,
  styleConfig,
  FirstRankIconImage,
  SecondRankIconImage,
  ThirdRankIconImage,
  IsTopRank,
  isXpImage,
  rewardHead,
  presentUserRank,
  DefaultImage,
  brandTheme,
  questThemeData,
  onUserClick,
  customUnit,
  customUnitImage
}) => {
  const { themeConfig } = useContext(QuestContext.Context);

  const themeManager = new LeaderboardThemeManager(
    themeConfig,
    styleConfig,
    questThemeData,
    brandTheme
  );

  const imageFix = (imageUrl: string) => {
    if (imageUrl && !imageUrl.includes("http")) {
      return `${config.BASE_IPFS_URL}${imageUrl}`;
    }
    return imageUrl;
  };

  const renderTopPosition = (
    player: any,
    position: number,
    rankImage: string | undefined,
    defaultRankImage: string
  ) => {
    if (!player) return null;

    const topRankStyles = themeManager.getTopRankStyles();

    return (
      <div
        className={`q_topleaderboard_${
          position === 1 ? "first" : position === 2 ? "second" : "third"
        }`}
        style={themeManager.getTopLeaderboardContainerStyles()}
        onClick={() => onUserClick && onUserClick(player)}
      >
        <div className="q_topleaderboard_innercard">
          <div
            className="q_top_leaderboard_inner_image_cont"
            style={{
              transform: IsTopRank
                ? "translate(-50%, -60%)"
                : "translate(-50%, -50%)",
            }}
          >
            {IsTopRank && (
              <div
                className="q_count_base_top"
                style={topRankStyles.indexNumber}
              >
                {position}
              </div>
            )}
            <img
              className={`q_topleaderboard_inner_image${
                position === 1 ? "_first" : ""
              }`}
              src={
                player.imageUrl
                  ? imageFix(player.imageUrl)
                  : DefaultImage || questLogo
              }
              alt="logo"
            />
          </div>
          <div className="q_topleaderboard_name" style={topRankStyles.name}>
            {player.name || "Quest User"}
          </div>
          <div className="q_topleaderboard_point_cont">
            {rewardHead && <p>{rewardHead}</p>}
            <div
              className="q_topleaderboard_point"
              style={topRankStyles.points}
            >
              {player.runningXP}{" "}
              {isXpImage ? <img src={XP} alt="xp" /> : customUnitImage || customUnit || "Points"}
            </div>
          </div>
          <img src={rankImage || defaultRankImage} alt={`rank-${position}`} />
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="q_topleaderboard_main_cont">
        <div className="q_topleaderboard_container">
          {renderTopPosition(second, 2, SecondRankIconImage, topLeadSecond)}
          {renderTopPosition(first, 1, FirstRankIconImage, topLeadFirst)}
          {renderTopPosition(third, 3, ThirdRankIconImage, topLeadThird)}
        </div>
      </div>

      <div
        style={themeManager.getInnerSectionStyles()}
        className="q_position_cont"
      >
        <div>
          <div
            className="q_position_heading"
            style={themeManager.getHeadingStyles()}
          >
            Leaderboard
          </div>
          <div
            className="q_description"
            style={themeManager.getDescriptionStyles()}
          >
            Your leaderboard gives you instant reference
          </div>
        </div>
        <div className="q_position_leaderboardcard_cont">
          {rest.length > 0 &&
            rest.map((item, index) => (
              <LeaderBoardCard
                key={index}
                index={index}
                memberShip={memberShip}
                item={item}
                styleConfig={styleConfig}
                isXpImage={isXpImage}
                presentUserRank={presentUserRank}
                DefaultImage={DefaultImage}
                brandTheme={brandTheme}
                questThemeData={questThemeData}
                onUserClick={onUserClick}
                customUnit={customUnit}
              />
            ))}
        </div>
      </div>
    </>
  );
};

export default TopLeaderBoard;
